import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col,
    Button,
    Tabs,
    Card,
    List as AntList,
    message,
    Empty,
    Icon,
    Tag,
    Avatar,
    Spin
    // Statistic,
    // Descriptions
} from "antd";
import CreditScoreCard from "./credit-score-card";
import SalesAnalysisTradeYear from "./sales-analysis-trade-year";
import FinalLimitApprovalList from "./final-limit-approval-list";
import BankStatementAnalysisTab from "./bank-statement-analysis-tab";
import DocumentComplianceSummary from "./document-compliance-summary";
import { formatCurrency } from "utilities/index";
import FinancialAnalysisRatios from "./financial-analysis-ratios";
// import TransactionAnalysisSummary from "./transaction-analysis-summary";
// import AnalysisSummaryView from "./analysis-summary-view";
import RemarksEditor from "./remarks-editor";
import { bindActionCreators } from "redux";
import {
    updateCaseDetail,
    fetchDocumentsChecklist,
    fetchCaseDocuments,
    fetchCaseSupplyChainDetails,
    fetchCaseSupplyChainFinancials,
    fetchScoreCard,

    initiateCaseState,
    fetchCompanyProfile,
    fetchCaseDetail,

    fetchStatement,
    approveCase,
    referCase,

    uploadDocuments,
    attachDocument,
    updateDocument,
    fetchCaseNotes,

    fetchJobsDetails,
    fetchJobsList,
    fetchStatementAnalysis,
    fetchStatementAnalysisPerfois,
    fetchCamEngineView,
    fetchCamEngineStatusLogs
} from "store/actions";
import { OrderedMap, Map, List } from "immutable";
// import * as jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { generateCreditSummaryPDF } from "utilities/credit-summary-pdf";
import { STATE_STATUS, CASE_VIEW_ACTION } from "constants";
import { Table } from "components/table";
import moment from "moment";
import BankDocumentView from "./bank-documents-view";
import "./../../styles/final-credit-summary.css";
import { BANK_ACCOUNT_TYPES, ADDRESSES_TYPES } from "constants/enums";
import { CaseService } from "../../services";
import CompanyService from "services/company-service";
import CAMView from "./cam-view";
import AssessmentReviewReport from "./AssessmentReviewReport";
import CreditSummary from "./credit-summary";
import caseSummaryTab from "./case-summary-tab";
import { report } from "process";
import camEngine from "./cam-engine";
import WelcomeQuestionareTab from "./welcome-questionare-tab";

const { TabPane } = Tabs;
const ListItem = AntList.Item;
const camEngineData =[];
const CIBIL_DETAILS = new OrderedMap({
    name: {
        title: "Name",
        key: "name",
        dataIndex: "name"
    },
    cibil_score: {
        title: "Credit Vision Score",
        key: "cibil_score",
        dataIndex: "cibil_score"
    },
    personal_cibil_score: {
        title: "Personal Loan Score",
        key: "personal_cibil_score",
        dataIndex: "personal_cibil_score"
    },
    cibil_remarks: {
        title: "Remarks",
        key: "cibil_remarks",
        dataIndex: "cibil_remarks"
    },
    cibil_report: {
        title: "CIBIL Report",
        key: "cibil_report.file",
        dataIndex: "cibil_report.file",
        // eslint-disable-next-line react/display-name
        render: _ => <a target={"_blank"} rel={"noreferrer"} href={_}>{_ && _.split("/").reverse()[0]}</a>
    },
    cibil_supported_report: {
        title: "CIBIL Supporting Documents",
        key: "cibil_supported_report",
        dataIndex: "cibil_supported_report",
        // eslint-disable-next-line react/display-name
        render: _ => (<ul>{_ && _.map((__, k) =>
            <li key={k}>
                <a key={String(__.id)} rel={"noreferrer"} target={"_blank"} href={__.file}>{__ && __.file && __.file.split("/").reverse()[0]}</a>    
            </li>
        )}</ul>)
    }
});

const COMPANY_ADDRESSES = new OrderedMap({
    address: {
        title: "Address",
        key: "address",
        dataIndex: "address_line_1",
        render: (val, _) =>
            _ &&
            ((_.address_line_1 ? _.address_line_1 : "") +
            " " +
            (_.address_line_2 ? _.address_line_2 : "")  +
            ", " +
            (_.city && _.city.name ? _.city.name : "") +
            ", " +
            (_.state && _.state.name ? _.state.name : "") +
            ", " +
            (_.pincode ? _.pincode : ""))
    },
    address_type: {
        title: "Address Type",
        key: "address_type",
        dataIndex: "address_type",
        render: (_) => Array.from(ADDRESSES_TYPES.filter(__ => __ === _).keys())[0]
    },
});

const COMPANY_BANK_ACCOUNTS = new OrderedMap({
    account_type: {
        title: "Account Type",
        key: "account_type",
        dataIndex: "account_type",
        render: (_) => Array.from(BANK_ACCOUNT_TYPES.filter(__ => __ === _).keys())[0]
    },
    account_holder_name: {
        title: "Account Holder Name",
        key: "account_holder_name",
        dataIndex: "account_holder_name"
    },
    account_number: {
        title: "Account Number",
        key: "account_number",
        dataIndex: "account_number"
    },
    account_limit: {
        title: "Account Limit",
        key: "account_limit",
        dataIndex: "account_limit"
    },
    ifsc_code: {
        title: "IFSC Code",
        key: "ifsc_code",
        dataIndex: "bank_branch",
        render:(_) => _.ifsc_code
    },
    bank_name: {
        title: "Bank",
        key: "bank_name",
        dataIndex: "bank_branch",
        render:(_) => _.bank_name
    },
    name: {
        title: "Branch",
        key: "name",
        dataIndex: "bank_branch",
        render:(_) => _.name
    },
});

const COMPANY_SUMMARY_LIST = new OrderedMap({
    associates: {
        label: "Name",
        title: "Name",
        key: "name",
        dataIndex: "name",
        value: ["John Mayer", "John Adams"].join(" | ")
    },
    email: {
        label: "Email",
        title: "Email",
        key: "email",
        dataIndex: "email",
        value: "john.adams@gmail.com"
    },
    phone: {
        label: "Phone",
        title: "Phone",
        key: "phone",
        dataIndex: "phone",
        value: "+91-9811299292"
    },
    pan: {
        label: "PAN",
        title: "PAN",
        key: "pan",
        dataIndex: "pan",
        value: "ZSXDC3213"
    },
    dob: {
        label: "Date of Birth",
        title: "Date of Birth",
        key: "dob",
        dataIndex: "dob",
        value: "ZSXDC3213",
        render: (_) => moment(_).format("DD/MM/YYYY")
    },
    // aadhar: {
    //     label: "Aadhar",
    //     title: "Aadhar",
    //     key: "aadhar",
    //     dataIndex: "aadhar",
    //     value: "ZSXDC3213"
    // },
    business_address: {
        label: "Address",
        title: "Address",
        key: "business_address",
        dataIndex: "business_address",
        value: "Some Address",
        width: 300,
        render: (_) => {
            if(!_){
                return "";
            }
            return _ &&
            ((_.address_line_1 ? _.address_line_1 : "") +
            " " +
            (_.address_line_2 ? _.address_line_2 : "")  +
            ", " +
            (_.city && _.city.name ? _.city.name : "") +
            ", " +
            (_.state && _.state.name ? _.state.name : "") +
            ", " +
            (_.pincode ? _.pincode : ""));
        }
    }
});

const CompanySummaryList = ({ company }) => {
    return (
        <Table
            size={"small"}
            columns={COMPANY_SUMMARY_LIST}
            data={company.associates.map(_ => {
                _.business_address = company.addresses.find(__ => __.associate === _.id);
                return _;
            }).toList()}
            noRowSelection={true}
            pagination={true}
            showTopSection={false}
            keyFilter={"id"}
        />
    );
};

CompanySummaryList.propTypes = {
    company: PropTypes.object
};

class FinalCreditSummary extends React.Component {
    state = {
        isRiskApprover: null,
        cibilDocuments: null,
        selectedJob: null,
        score_details: null,
        creditAssessmentData: null,
        caseAISummaryAutomation : {},
        caseAISummaryAutomationLoading: true,
        caseAISummaryAutomation400: false,
    }
    rowRef = React.createRef();

    // CALL THIS API TO GET CAMS DATA
    // getCreditSummaryReportData = () => {
    //     message.loading("Fetching File...");
    //     if((!this.props.camEngineData || Object.keys(this.props.camEngineData).length==0)){
    //         this.props.fetchCamEngineView(this.props.caseId);
    //     }else{
    //         this.printCreditSummaryFn();
    //     }
    // }
   
    savePdf = async (reportType,sanctionText) => {  
        const cam_view_demo = [84770, 89159, 82747, 85316, 75215, 92218, 86542, 107956, 115692, 56673, 100546, 104530, 120439, 117446, 84273, 102605, 74125, 111222, 118652, 106990, 110491, 124511, 134142, 96675, 118330, 80899, 122567, 135881, 139625,109582, 91585, 137796, 139149, 136282, 118292, 125833, 139379, 138844, 125191, 125225, 137439, 138604, 140515].includes(this.props.caseId)
        const credit_summary_demo = [65463, 75051, 79013, 79015, 84972, 125258, 74966, 78148, 82004, 76709, 29896, 99216, 102418, 104523, 107413, 110578, 112898, 115417, 117789, 125410, 75215, 76578, 97663, 104111, 90443, 83325, 80899, 91578, 105979, 109879, 112216, 121216, 122552, 92403, 102065, 90811, 92218, 92446, 97669, 117167, 123160, 97799, 98918, 104731, 117634, 118478, 125435, 82427, 85319].includes(this.props.caseId)
        const limit = this.props.company.bank_accounts &&
            this.props.company.bank_accounts
                .toList()
                .reduce(
                    (agg, _) =>
                        _.account_limit
                            ? +_.account_limit +
                            agg
                            : agg,
                    0
                ) +
                (this.props.proposed_limit
                    ? +this.props
                        .proposed_limit
                    : 0);
        const statements = this.props.statements && this.props.statements.toList().getIn([0,"data"]) || new Map({});
        const data = statements.toList().reduce(
            (agg, _) => {
                agg.balance += _.total_balance;
                agg.inward_cheque += _.total_inward_cheque;
                agg.outward_cheque += _.total_outward_cheque;
                agg.outward_cheque_bounce += _.total_outward_cheque_bounce;
                agg.inward_cheque_bounce += _.total_inward_cheque_bounce;
                return agg;
            },
            {
                balance: 0,
                inward_cheque_bounce: 0,
                inward_cheque: 0,
                outward_cheque_bounce: 0,
                outward_cheque: 0
            }
        );

        let averageBalance = statements.size
            ? formatCurrency(Math.round(
                data.balance /
                        (statements.size *
                            statements.first().key_size)
            ))
            : "--";

        let outward_cheque_bounce_perc = data.outward_cheque > 0 ? Math.round(
            (data.outward_cheque_bounce / data.outward_cheque) * 100
        ) : "--";
        
        let inward_cheque_bounce_perc = data.inward_cheque > 0 ? Math.round(
            (data.inward_cheque_bounce / data.inward_cheque) * 100
        ) : "0%";

        let avg_bank_balance_to_limit_perc = limit && statements.size
            ? (
                (data.balance /
                        (statements.size *
                            statements.first()
                                .key_size) /
                        limit) *
                    100
            ).toFixed(1)+"%"
            : "--";
        const stats = this.props.bankStatementAnalyser && this.props.bankStatementAnalyser.getIn(["statementAnalysis", this.state.selectedJob, "data"]);
        let analysisMap = {
            sixMonthAvgInwardBouncingPercent: stats && (stats.sixMonthAvgInwardBouncingPercent || stats.overallAvgInwardBouncingPercent),
            sixMonthAvgOutwardBouncingPercent: stats && (stats.sixMonthAvgOutwardBouncingPercent || stats.overallAvgOutwardBouncingPercent),
            monthlyCreditRunningAvgWithReturns: stats && (stats.monthlyCreditRunningAvgWithReturns),
            monthlyDebitRunningAvgWithReturns: stats && (stats.monthlyDebitRunningAvgWithReturns),
            monthlyNumberOfContraEmi: stats && (stats.monthlyNumberOfContraEmi),
            monthlyAvgBalance: stats && (stats.monthlyAvgBalance)
        };

        const excludeKeys = [
            'negative_area',
            'growth_gst_turnover_24_months',
            'geo_portfolio_in_due_date',
            'geo_portfolio_in_90_plus_dpd',
            'recourse_perc',
            'retailer_risk_holdback_perc',
            'mpa_risk_category',
            'anchor_portfolio_in_due_date',
            'anchor_portfolio_in_90_plus_dpd',
            'db_profitability',
            'db_portfolio_in_due_date',
            'db_portfolio_in_90_plus_dpd',
            'percentage_total_outstanding_payable',
            'dedupe_flag_as_input',
            'sanction_limit_to_90th_percentile_limit',
            'gst_turnover_match_anchor_purchase',
            'program_size_os',
            'recourse_structure',
            'anchor_profitability',
            'proposed_max_ticket_size_in_lacs',
            'scheme_check'
        ];

        let cam_data = this.props.camEngineData;
        Object.values(cam_data).forEach(obj => {
            if (obj.category === "Anchor") {
                obj.output = true;
            }
            if ([80899,122567,135881,118330,139625,84770,86542,96675,82747,110491,118652,85316,124511,75215,84273,134142,74125,115692,89159,92218,107956, 109582, 91585, 137796, 139149, 136282, 118292, 125833, 139379, 138844, 125191, 125225, 137439, 138604, 140515].includes(this.props.caseId) && obj.key2 == 'anchor_name'){
                obj.fact_value = 'Approved';
            }
            if ([80899,122567,135881,118330,139625,84770,86542,96675,82747,110491,118652,85316,124511,75215,84273,134142,74125,115692,89159,92218,107956, 109582, 91585, 137796, 139149, 136282, 118292, 125833, 139379, 138844, 125191, 125225, 137439, 138604, 140515].includes(this.props.caseId) && ['stop_supply', 'stock_liquidation', 'termination_intimation'].includes(obj.key2)){
                obj.fact_value = 'Yes';
            }

        });
        const filtered = cam_view_demo ? Object.fromEntries(
            Object.entries(cam_data).filter(
                ([key, val]) => !(val.category === 'MPA' || excludeKeys.includes(key))
            )
        ) : this.props.camEngineData;
        const categoryOrder = ["Profile", "General", "Ledger", "Banking", "GST", "Financial", "Geography", "DB", "Anchor", "Anchor MPA", "Bureau", "MPA", "Financials"];
        const  preparedData = { camEngineData: Object.entries(filtered)

         .map(([key,el ]) => ({
                    "category": el?.category,
                    "fact_name": el?.fact_name,
                    "policy": typeof el?.policy == "boolean" ? String(el?.policy)  : el?.policy ||  "NA",
                    "fact_value": el?.fact_value === true ? "True" : (el?.fact_value === false || el?.fact_value === "" || el?.fact_value === null) ? "False" : el?.fact_value,
                    "output": el?.output === true ? "Pass": el?.output === false ? "Fail": "Not Applicable",
                    "approval_level": el?.approval_level,
                    "deviation": el?.deviation === "Yes" ? el.deviation_reason : el?.deviation === "No" ? "" : "",
                    "credit_remarks": el?.credit_remarks||" ",

                    "key2": el?.key2,
                    "approval_mandatory": el?.approval_mandatory,
          }))
          .sort((a, b) => {
            const indexA = categoryOrder.indexOf(a.category);
            const indexB = categoryOrder.indexOf(b.category);
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
          })
          .map((item, index) => ({
            ...item,
            sno: index + 1 
          })),                    
                net_sales_amount_last_12_months: formatCurrency(
                    +(this.props.supplyChainRecord && this.props.supplyChainRecord.get("net_sales_amount_last_12_months") || ""),
                    // +this.props.caseDetail.last_12_month_sales,
                    true
                ),
                avg_monthly_net_sales: formatCurrency(
                    +(this.props.supplyChainRecord && this.props.supplyChainRecord.get("avg_monthly_net_sales") || ""),
                    // (+this.props.caseDetail.average_monthly_net_sales),
                    true
                ),
                limit_basis_sales_display: formatCurrency(
                    // (+this.props.caseDetail.limit_basis_sales)
                    (+(this.props.supplyChainRecord && this.props.supplyChainRecord.get("limit_basis_sales_display") || "")),
                ),
                constitution:  this.props.company.constitution_name,
                sellers: this.props.caseDetail.sellers.map(_ => _.short_name).join(", "),
                anchors: this.props.caseDetail.anchors_list.map(_ => _.split("|")[0]).join(", "),
                caseDetail: {
                    ...this.props.caseDetail.toJS(),
                    proposed_limit: formatCurrency(this.props.caseDetail.proposed_limit),
                    supply_chain: {
                        ...this.props.caseDetail.supply_chain,
                        sales_amount_last_12_months: formatCurrency(this.props.caseDetail.supply_chain.sales_amount_last_12_months),
                        avg_monthly_net_sales: formatCurrency(this.props.caseDetail.supply_chain.avg_monthly_net_sales)
                    },
                },
                company: this.props.company,
                financials: this.props.financials?.getRows(
                    String(
                        this.props.caseDetail &&
                            this.props.caseDetail.get(
                                "sales_analysis_display_type"
                            )
                    )
                ).toArray().map(_ => ({
                    year: _.year,
                    Apr: formatCurrency(_.Apr),
                    May: formatCurrency(_.May),
                    June: formatCurrency(_.June),
                    July: formatCurrency(_.July),
                    Aug: formatCurrency(_.Aug),
                    Sep: formatCurrency(_.Sep),
                    Oct: formatCurrency(_.Oct),
                    Nov: formatCurrency(_.Nov),
                    Dec: formatCurrency(_.Dec),
                    Jan: formatCurrency(_.Jan),
                    Feb: formatCurrency(_.Feb),
                    Mar: formatCurrency(_.Mar),
                })),
                addresses: this.props.company.addresses.toList().toArray(),
                registered_address: this.props.company.addresses.find(_ => _.address_type === 1),
                operating_address: this.props.company.addresses.find(_ => _.address_type === 2),
                scorecard: this.props.scorecard,
                supplyChainScoreComposite: String(this.props.scorecard.getIn([1, "data"], {}).composite_score || ""),
                supplyChainScoreTotal: String(this.props.scorecard.getIn([1, "data"], {}).total_weight || ""),
                lenderScoreComposite: String(this.props.scorecard.getIn([2, "data"], {}).composite_score || ""),
                lenderScoreTotal: String(this.props.scorecard.getIn([2, "data"], {}).total_weight || ""),
                associates: this.props.caseAssociates.toList().map(_ => ({
                    // dob_and_age: _.dob_and_age,
                    address: this.props.company.addresses.toList().toArray().find(__ => __.associate == _.company_associate.id),
                    first_name: _.company_associate.first_name,
                    last_name: _.company_associate.last_name,
                    phone: _.company_associate.phone,
                    pan: _.company_associate.pan,
                    dob_and_age: _.company_associate.dob ? `${moment().diff(_.company_associate.dob, "years")} years` : null,        
                    ..._.toJS()
                })),
                averageBalance: averageBalance,
                inwardChequeBouncePerc: inward_cheque_bounce_perc,
                outwardChequeBouncePerc: outward_cheque_bounce_perc,
                abbToLimit: avg_bank_balance_to_limit_perc,
                analysisMap,
                statements:
                    this.props.statements &&
                    this.props.statements.toList().getIn([0,"data"]).toList().toJS().map(_ => 
                        ({
                            ..._, 
                            txn_month_year: _.txn_month_year.format("MMM-YYYY"),
                            balance: {
                                ..._.balance,
                                balance_10th: {
                                    ..._.balance.balance_10th,
                                    value: formatCurrency(_.balance.balance_10th.value)
                                },
                                balance_20th: {
                                    ..._.balance.balance_20th,
                                    value: formatCurrency(_.balance.balance_20th.value)
                                },
                                balance_30th: {
                                    ..._.balance.balance_30th,
                                    value: formatCurrency(_.balance.balance_30th.value)
                                }
                            }
                        })) || [],
                supplyChainDetail: {
                    ...this.props.supplyChainRecord.toJS(),
                    limit_basis_sales_display: formatCurrency(this.props.supplyChainRecord.limit_basis_sales_display)
                },
                bankAccounts: this.props.company.get("bank_accounts") && this.props.company.get("bank_accounts").toList().toArray().map(_ => ({
                    ..._.toJS(),
                    account_type: BANK_ACCOUNT_TYPES.findKey(__ => __ == _.account_type)
                })) || [],
                // camViewData: this.props.camEngineData,
                scoreCard: this.state.score_details && this.state.score_details.map(item => ({
                    label: item.label,
                    value: typeof item.value === 'object' ? null : item.value
                })),
                scoreCardBar: this.props.scorecard && this.props.scorecard.getIn([2, "data", "score"]),
                creditAssessmentData: this.state.creditAssessmentData && this.state.creditAssessmentData.filter(_ => _ && _.visible).map((_, k) => {
                    let row = _;
                    if(row && typeof row === "object") {
                        row.key = k;
                        row.sno = _.sno;
                        row.value = _.value;
                        row.category = _.category || "--";
                        row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                        row.remarks = _.deviation === "No"  ? _.remarks || "--" : _.remarks;
                    }
                    return row;
                }).toList().sort((a, b) => {
                    if((a && a.sno) > (b && b.sno))
                        return 1;
                    return -1;
                }),
                sanctionText: sanctionText || "",
                sanctionDate: sanctionText ? moment().format("DD-MM-YYYY") : "",
                caseNotes: this.props.caseComments.get("notes").toList().toArray().flat().map(_ => _.toJS()).sort((a,b) => a.create_date.format("YYYYMMDD") - b.create_date.format("YYYYMMDD"))
        }
        let response = {};
        if (reportType === "credit_summary") {
            message.loading("Generating credit summary document...", 3);
            if (credit_summary_demo) {
                response = await CaseService.generateCreditSummaryDemoV2({
                    data: preparedData,
                    isBase64: true
                })
            } else {
                response = await CaseService.generateCreditSummary({
                    data: preparedData,
                    isBase64: true
                })
            }
        
    }
     else{
            message.loading("Generating Cam-view  document...", 3);
            if (cam_view_demo) {
                response = await CaseService.generategetCamviewV2({
                    data: preparedData,
                    isBase64: true
                })
            } else {
                response = await CaseService.generategetCamview({
                    data: preparedData,
                    isBase64: true
                })
            }
    }
       const link = document.createElement("a");
         link.href = `data:application/pdf;base64,${response.data.data}`
        reportType === "credit_summary"?
        link.setAttribute("download", `credit-summary-${this.props.caseId}`): link.setAttribute("download", `Cam-view -${this.props.caseId}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        // return generateCreditSummaryPDF({
        //     caseDetail: this.props.caseDetail,
        //     company: this.props.company,
        //     scorecard: this.props.scorecard,
        //     statements:
        //         this.props.statements &&
        //         this.props.statements
        //             .toList()
        //             .first()
        //             .get("data")
        //             .toList(),
        //     supplyChainDetail: this.props.supplyChainRecord
        // });
    };

    fetchCaseAISummaryAutomation = (refresh = false) => {
        this.setState({ caseAISummaryAutomation400: false, caseAISummaryAutomationLoading: true });
        CaseService.caseAISummaryAutomation(this.props.caseId, refresh)
            .then(({ data }) => {
                this.setState({
                    caseAISummaryAutomation: (data['choices'][0] && data['choices'][0]['message']) ? JSON.parse(data['choices'][0]['message']['content']) : {},
                    caseAISummaryAutomationLoading: false,
                    caseAISummaryAutomation400: false
                });
            })
            .catch((err) => {
                console.log('err.responserr.response.status', err)
                const is400 = err.status === 404;
                this.setState({
                    caseAISummaryAutomationLoading: false,
                    caseAISummaryAutomation400: is400
                });
            });
    };

    componentDidMount() {
        if(this.props.stageId !== 7){
            this.fetchCaseAISummaryAutomation();
        }
        this.handleChecklistFetch();
        this.props.fetchCaseNotes(this.props.caseId);
        this.handleDocumentsFetch();
        this.handleScoreCardFetch();
        this.handleSupplyChainRecordFetch();
        this.props.fetchJobsList(this.props.caseId);
        this.handleCaseDetailsActions();
        CompanyService.getCibilDocuments(this.props.caseId).then(_ => {
            this.setState({
                cibilDocuments: _.data && _.data.results
            });
        });
    } 
    printCreditSummaryFn = ( ) => {
        CaseService.getCreditAssessment(this.props.caseId)
        .then(res => {
            this.setState({
                creditAssessmentData: res.data && new OrderedMap(res.data.data),
            }, () => {                 
                this.savePdf("credit_summary"," ")
            })
        })
        .catch(() => {});
    }
  printcamviewfn = () => {
        CaseService.getCreditAssessment(this.props.caseId)
        .then(res => {
            this.setState({
                creditAssessmentData: res.data && new OrderedMap(res.data.data),
            }, () => {
                this.savePdf ("cam_view"," ")
            })
        })
        .catch(() => {});
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.bankStatementAnalyser.getIn(["jobList", "status"]) ==  STATE_STATUS.FETCHED && prevProps.bankStatementAnalyser.getIn(["jobList", "status"]) == STATE_STATUS.FETCHING){
            const jobList = this.props.bankStatementAnalyser && this.props.bankStatementAnalyser.getIn(["jobList", "data"]);
            if(jobList.size || jobList.length) {
                let usedJob = jobList.find(_ => _.using);
                if(usedJob) {
                    this.props.fetchStatementAnalysis(this.props.caseId, usedJob && usedJob.analysis_request);
                    this.setState({
                        selectedJob: usedJob.analysis_request
                    })
                }
            }
            
        }
        
        // Use to call print fn after cam api fn

        // if (prevProps.camEngineStatus === STATE_STATUS.FETCHING && this.props.camEngineStatus === STATE_STATUS.FETCHED) {
        //     this.printCreditSummaryFn()
        // }
        
        this.handleChecklistFetch();
        // this.handleDocumentsFetch();
        this.handleScoreCardFetch();
        this.handleSupplyChainRecordFetch();
        this.handleBankStatementFetch();
        // this.handleCaseDetailsActions();
    }

    async handleCaseDetailsActions() {
        if (this.props.caseId) {
            this.props.initiateCaseState(this.props.caseId);
        }
        if (
            this.props.companyId &&
            this.props.action === CASE_VIEW_ACTION &&
            (!this.props.companyStatus ||
                this.props.companyStatus.get("companyStatus") ===
                    STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyProfile(this.props.companyId, this.props.caseId);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.status === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseDetail(this.props.caseId);
        }
        if (
            this.props.status === STATE_STATUS.FETCHED &&
            this.props.companyStatus &&
            this.props.companyStatus.get("companyStatus") ===
                STATE_STATUS.FETCHED
        ) {
            this.setState({
                visible: true
            });
        }
        if(this.props.userStatus === "FETCHED" && this.state.isRiskApprover === null) {
            let group = this.props.user && this.props.user.getIn(["data", "groups"]).filter(_ => _.id === 8);
            this.setState({
                isRiskApprover: group.size || group.length ? true : false
            });
        }
    }

    async handleBankStatementFetch() {
        try {
            if (
                this.props.activeBankAccountKey && (!this.props.statements ||
                (this.props.statements && !this.props.statements.getIn([
                    Number(this.props.activeBankAccountKey),
                    "status"
                ]))) ||
                this.props.statements && this.props.statements.getIn([
                    Number(this.props.activeBankAccountKey),
                    "status"
                ]) === STATE_STATUS.UNFETCHED
            ) {
                this.props.fetchStatement(
                    this.props.caseId,
                    Number(this.props.activeBankAccountKey)
                );
            }
        } catch (error) {
            console.error(error);
        }
    }
    async handleScoreCardFetch() {
        if (
            !this.props.scorecard ||
            !this.props.scorecard.getIn([1, "status"]) ||
            this.props.scorecard.getIn([1, "status"]) === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchScoreCard(this.props.caseId, 1);
        }
        if (
            !this.props.scorecard ||
            !this.props.scorecard.getIn([2, "status"]) ||
            this.props.scorecard.getIn([2, "status"]) === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchScoreCard(this.props.caseId, 2);
        }
    }

    async handleSupplyChainRecordFetch() {
        if (this.props.supplyChainStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseSupplyChainDetails(this.props.caseId);
        }
    }
    async handleChecklistFetch() {
        if (
            this.props.caseId &&
            (!this.props.checklist ||
                this.props.checklist.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchDocumentsChecklist(
                this.props.caseId,
                "pre-sanction"
            );
        }
    }
    async handleDocumentsFetch() {
        if (
            this.props.caseId &&
            (!this.props.documents ||
                this.props.documents.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCaseDocuments(
                this.props.caseId,
                this.props.companyId,
                true
            );
        }
    }

    onSalesDisplayChange = (displayYear, displayCurrency) => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail
                .set("sales_analysis_display_type", Number(displayYear))
                .set("sales_analysis_display_currency", Number(displayCurrency))
        );
    };

    getCibil = () => {
        let isCibil = this.props.company.get("associates")
            .toList()
            .filter(_ =>
                _.cibil_score !== 0 && _.cibil_score !== null
            );
        return isCibil.size;
    }

    getAssociatesData = () => {
        let caseAssociates = (this.props.caseAssociates && this.props.caseAssociates.map(_ => _.company_associate && _.company_associate.id).toArray()) || [];
        let associatesList = this.props.company && this.props.company.associates.filter(_ => caseAssociates.includes(_.id));
        associatesList = associatesList && associatesList.withMutations(list => 
            list.map(_ => {
                let caseAssociateDetail = this.props.caseAssociates.find(__ => _.id == (__.company_associate && __.company_associate.id));
                if(caseAssociateDetail) {
                    return _.setIn(["case_level_data"], caseAssociateDetail);
                }
                return _;
            })
        );
        return associatesList;
    }

    updateScoreDetails = (updatedScoreDetails) => {
        this.setState({ score_details: updatedScoreDetails });
    };

    render() {
        const pdDoc = this.props.documents && this.props.documents.get("data").toList().map(_ => _.get("data")).find(_ => _ && _.document === 60);
        let sum_of_bank_stmt =
            this.props.statements &&
            this.props.activeBankAccountKey &&
            this.props.statements.getIn([
                this.props.activeBankAccountKey,
                "data"
            ]) &&
            this.props.statements
                .getIn([this.props.activeBankAccountKey, "data"])
                .toList()
                .reduce((agg, _) => agg + +_.total_balance, 0);
        
        let associatesData = this.getAssociatesData();
        // const documentSize = this.props.checklist.get("data") && this.props.checklist.get("data").length && this.props.checklist.get("data").map(_ => {
        //     const requiredDocuments = _.documents.map(_ => _.id);
        //     const uploadedDocumentsSize = this.props.documents.get("data")
        //         ? this.props.documents
        //             .get("data")
        //             .map(__ => __.get("data"))
        //             .groupBy(__ => __.document)
        //             .filter((v, k) => requiredDocuments.includes(k)).size : 0;
        //     return uploadedDocumentsSize;
        // }).reduce((agg, v) => agg + +v, 0);
        // if(this.props.supplyChainRecord) {
        //     console.log("Saurav Bansal", this.props.supplyChainRecord.toJS());
        // }
        const rationaleList = Object.keys(this.state.caseAISummaryAutomation).length ?  this.state.caseAISummaryAutomation['rationale']
            .split('.')
            .map(item => item.trim())
            .filter(item => item.length) : [];

        const finalDecision = (this.state.caseAISummaryAutomation['final_decision'] || '').toString().toLowerCase();
        const finalDecisionTagColor = ['approve', 'approved'].includes(finalDecision) ? 'green' : finalDecision === 'reject' ? 'red' : '#f59e0b';

        let supplyChainAnchorZetwerk = this.props.caseDetail.supply_chains.find(el=>el.anchor.name === "Zetwerk Manufacturing Businesses Private Limited" || el.anchor.name ==="Hella Infra Market Private Limited");
        return (
            <div id={"printable-summary"}>
                <Row className={"p-5"}>
                    {![141834 , 130090].includes(this.props.caseId) && <Col span={24} className={"pl-10"}>
                        <Button
                            size={"small"}
                            type={"primary"}
                            icon={"printer"}
                            disabled={this.props.camEngineStatus === STATE_STATUS.FETCHING}
                            onClick={() => this.printCreditSummaryFn()}
                            style={{ marginRight: '16px' }} 
                        >
                            Print 
                    </Button>                  
                    <Button
                        size="small"
                        type="primary"
                        icon="printer"
                        onClick={() => this.printcamviewfn()}
                        >
                        Cam View
                        </Button>
                    </Col>  }                    
                    <Col span={24}>
                        {/* {![141834, 130090].includes(this.props.caseId) && <CreditScoreCard
                            {...this.props}
                            company={this.props.company}
                            caseDetail={this.props.caseDetail}
                            updateScoreDetails={this.updateScoreDetails} 
                            caseAssociates={this.props.caseAssociates}
                            scorecard={this.props.scorecard}
                            statements={this.props.statements && this.props.statements.getIn([
                                Number(this.props.activeBankAccountKey),
                                "data"
                            ])}
                            balance={sum_of_bank_stmt}
                            supplyChain={this.props.supplyChainRecord}
                            limit={
                                this.props.company &&
                                this.props.company.bank_accounts &&
                                this.props.company.bank_accounts
                                    .toList()
                                    .reduce(
                                        (agg, _) =>
                                            _.account_limit
                                                ? +_.account_limit +
                                                  agg
                                                : agg,
                                        0
                                    ) +
                                    (this.props.proposed_limit
                                        ? +this.props.proposed_limit
                                        : 0)
                            }
                        />} */}
                        <Col span={[130090, 141834].includes(this.props.caseId) ? 24 :  24} className={"p-10"}>
                            <Row>
                                <AntList grid={{ gutter: 16, column: 4 }}>
                                    <ListItem className={"pb-10 pr-5"} key={"Sales with Anchor"}>
                                        <Card
                                            className={"small-card-title"}
                                            title={
                                                `Last ${this.props.supplyChainRecord && this.props.supplyChainRecord.get("net_sales_amount") && this.props.supplyChainRecord.get("net_sales_amount").months || "12"} Months Sales`
                                            }>
                                            {formatCurrency(
                                                +(this.props.supplyChainRecord && this.props.supplyChainRecord.get("net_sales_amount") && this.props.supplyChainRecord.get("net_sales_amount").amount || ""),
                                                true
                                            )}
                                        </Card>
                                    </ListItem>
                                    <ListItem className={"pb-10 pr-5"} key={"Proposed Limit"}>
                                        <Card
                                            className={"small-card-title"}
                                            title={"Monthly Sales"}>
                                            {" "}
                                            {formatCurrency(
                                                +(this.props.supplyChainRecord && this.props.supplyChainRecord.get("avg_monthly_net_sales") || ""),
                                                // (+this.props.caseDetail.average_monthly_net_sales),
                                                true
                                            )}
                                        </Card>
                                    </ListItem>
                                    <ListItem className={"pb-10 pr-5"} key={"Tenure"}>
                                        <Card
                                            className={"small-card-title"}
                                            title={`Limit as per ${(this.props.caseDetail && this.props.caseDetail.tenure) || ""} day sales`}>
                                            { formatCurrency(
                                                // (+this.props.caseDetail.limit_basis_sales)
                                                (+(this.props.supplyChainRecord && this.props.supplyChainRecord.get("limit_basis_sales_display") || "")),
                                            ) }
                                        </Card>
                                    </ListItem>
                                    <ListItem className={"pb-10"} key={"Computed Limit"}>
                                        <Card
                                            className={"small-card-title"}
                                            title={"Proposed Limit"}>
                                            {formatCurrency(
                                                +this.props.caseDetail.proposed_limit,
                                                true
                                            )}
                                        </Card>
                                    </ListItem>
                                </AntList>
                            </Row>
                            <RemarksEditor
                                remarks={this.props.caseDetail.remarks}
                                readOnly={true}
                            />
                            {this.props.stageId !== 7 && <Spin spinning={ this.state.caseAISummaryAutomationLoading}>
                            <Card className="mt-10 ai-custom-card" style={{ "borderRadius": 10 }} >
                                <Row>
                                    <Col span={12}>                                        
                                        <AntList.Item.Meta
                                            className="custom-meta"
                                            avatar={<Avatar size={30} icon={<Icon type="star" />} />}
                                            title="Lumi's View (In beta)"
                                            description="AI-Powered Assessment"
                                        />
                                    </Col>
                                    <Col span={12} className="text-right">
                                        {this.state.caseAISummaryAutomation400 ? (
                                            <Button
                                                type="primary"
                                                icon="reload"
                                                onClick={() => this.fetchCaseAISummaryAutomation(true)}
                                            >
                                                Refresh
                                            </Button>
                                        ) : (
                                        <Tag
                                            style={{
                                                borderRadius: 25,
                                                padding: 10,
                                                color: 'white',
                                                ...(['approve', 'approved'].includes(finalDecision) && { backgroundColor: '#00A300', borderColor: '#00A300' }),
                                                ...(finalDecision === 'reject' && { backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' })
                                            }}
                                            color={finalDecisionTagColor}
                                        >
                                            {!['approve', 'approved'].includes(finalDecision) && (
                                                <Icon type="warning" size="20" style={{ marginRight: 6 }} />
                                            )}
                                            {this.state.caseAISummaryAutomation['final_decision']}
                                        </Tag>
                                        )}
                                    </Col>
                                </Row>
                                <Card className="mt-10 ai-custom-card" style={{ "borderRadius": 10, background: "#ebf4ef"}} >
                                    <AntList.Item.Meta
                                        className="custom-meta"
                                        avatar={<Avatar size={30} className="rupee-avatar">
                                            ₹
                                        </Avatar>}
                                        title="Suggested Safe Limit"
                                        description={this.state.caseAISummaryAutomation['suggested_safe_limit']}
                                    />

                                </Card>
                                <Card className="mt-10 ai-custom-card" style={{ "borderRadius": 10 , background: "#f5f7f7"}} >
                                    <h5 style={{ textTransform: 'upperCase', fontWeight : 600}}><span className="custom-bullet mr-5"></span>Case Summary</h5>
                                    {this.state.caseAISummaryAutomation['short_case_summary'] ? <AntList
                                        className="compact-list"
                                        dataSource={this.state.caseAISummaryAutomation['short_case_summary']}
                                        renderItem={(item, index) => (
                                            <AntList.Item>
                                                <div className="summary-item">
                                                    <span className="summary-index">
                                                        {index + 1}
                                                    </span>
                                                    <span className="summary-text">
                                                        {item}
                                                    </span>
                                                </div>
                                            </AntList.Item>
                                        )}
                                    /> : <></>}
                                </Card>
                                <Card className="mt-10 ai-custom-card" style={{ "borderRadius": 10, background: "#fefaf5"}} >
                                    <h5 style={{color: "#f6a318", textTransform: 'upperCase', fontWeight : 600}}><Icon type="bulb" className="mr-5"/>Decision Rationale</h5>
                                    <Card className="ai-custom-card" style={{ "borderRadius": 10, background: "#fffcfa"}}>
                                        {rationaleList.length ? <>
                                        <AntList
                                            className="compact-list"
                                            dataSource={rationaleList}
                                            renderItem={(item, index) => (
                                                <AntList.Item>
                                                    <div className="summary-item">
                                                        <span className="summary-bullet" />
                                                        <span className="summary-text">
                                                            {item}
                                                        </span>
                                                    </div>
                                                </AntList.Item>
                                            )}
                                        /></> : <p></p>}
                                    </Card>
                                </Card>
                            </Card>
                            </Spin> }
                        </Col>
                    </Col>
                    {/* <Col className={"p-10"} span={24}>
                        <Card className={"padless-card transparent-no-Border p-5"} tabPosition={"top"} style={{ minHeight: !this.props.isRiskApprover ? "unset" : 460 }}>
                            <Tabs className={"ml-0"}
                                defaultActiveKey={"sales"}
                            >
                                <TabPane className={"ml-0"} tab="Sales Analysis" key="sales">
                                    <SalesAnalysisTradeYear
                                        displayYear={String(
                                            this.props.caseDetail &&
                                                this.props.caseDetail.get(
                                                    "sales_analysis_display_type"
                                                )
                                        )}
                                        displayCurrency={String(
                                            this.props.caseDetail &&
                                                this.props.caseDetail.get(
                                                    "sales_analysis_display_currency"
                                                )
                                        )}
                                        onSalesDisplayChange={
                                            this.onSalesDisplayChange
                                        }
                                        salesDisplayDisabled={true}
                                        tradeYearMonth={7}
                                        noPermissionRequired={true}
                                        financials={this.props.financials}
                                        financialsStatus={
                                            this.props.financialsStatus
                                        }
                                        fetch={
                                            this.props
                                                .fetchCaseSupplyChainFinancials
                                        }
                                        caseId={this.props.caseId}
                                    />
                                </TabPane>
                                {(!this.props.activeBankAccountKey &&
                                    !sum_of_bank_stmt || !this.props.use_statement_analyzer) && (["CIFCL", "MF"].includes(this.props.bankCode) && supplyChainAnchorZetwerk !== undefined) ? null :
                                    (<TabPane className={"ml-0"} tab="Bank Statement" key="credit_summary">
                                        <BankStatementAnalysisTab
                                            permission={"credit_summary_view"}
                                            bankCode={this.props.bankCode}
                                            caseId={this.props.caseId}
                                            caseDetail={this.props.caseDetail}
                                            updateCaseDetail={this.props.updateCaseDetail}
                                            isSummary={true}
                                            companyId={this.props.companyId}
                                            use_statement_analyzer={this.props.use_statement_analyzer}
                                            isCreateStatement={false}
                                            lendingPartner={this.props.lendingPartner}
                                            bankStatementAnalyser={this.props.bankStatementAnalyser}
                                            fetchJobsList={this.props.fetchJobsList}
                                            fetchJobsDetails={this.props.fetchJobsDetails}
                                            fetchStatementAnalysis={this.props.fetchStatementAnalysis}
                                            fetchStatementAnalysisPerfois={this.props.fetchStatementAnalysisPerfois}
                                            statements={this.props.statements}
                                            hideStatement={false}
                                            hideColumnSelector={true}
                                            accounts={
                                                this.props.company && this.props.company.bank_accounts
                                            }
                                            fetchStatement={
                                                this.props.fetchStatement
                                            }
                                            limit={
                                                this.props.company &&
                                                this.props.company
                                                    .bank_accounts &&
                                                this.props.company.bank_accounts
                                                    .toList()
                                                    .reduce(
                                                        (agg, _) =>
                                                            _.account_limit
                                                                ? +_.account_limit +
                                                                agg
                                                                : agg,
                                                        0
                                                    ) +
                                                (this.props.proposed_limit
                                                    ? +this.props
                                                        .proposed_limit
                                                    : 0)
                                            }
                                            type="inner"
                                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                        />
                                    </TabPane>
                                    )}
                                <TabPane className={"ml-0"} tab="Applicants" key="applicants">
                                    <CompanySummaryList company={this.props.company} />
                                </TabPane>
                                {(!this.props.caseDetail
                                    .is_financial_analysis_applied) && (["CIFCL", "MF"].includes(this.props.bankCode) && supplyChainAnchorZetwerk !== undefined) ? null :
                                    (
                                        <TabPane className={"ml-0"} tab="Financial Analysis" key="financial">
                                            <FinancialAnalysisRatios
                                                companyId={this.props.companyId}
                                            />
                                        </TabPane>
                                    )}
                                <TabPane className={"ml-0"} tab="Document Compliance" key="documents">
                                    <DocumentComplianceSummary
                                        checklist={this.props.checklist}
                                        documents={this.props.documents}
                                        showDocuments={this.props.openDocView}
                                        caseId={this.props.caseId}
                                        companyId={this.props.companyId}
                                        companyName={this.props.companyName}
                                    />
                                </TabPane>
                                <TabPane className={"ml-0"} tab="Addresses" key="addresses">
                                    <Table
                                        size={"small"}
                                        columns={COMPANY_ADDRESSES}
                                        data={this.props.company && this.props.company.get("addresses").toList()}
                                        pagination={true}
                                        showTopSection={false}
                                        noRowSelection={true}
                                        keyFilter={"id"}
                                    />
                                </TabPane>
                                <TabPane className={"ml-0"} tab="Bank Accounts" key="bankAccounts">
                                    <Table
                                        size={"small"}
                                        columns={COMPANY_BANK_ACCOUNTS}
                                        data={((this.props.company && this.props.company.get("bank_accounts") && this.props.company.get("bank_accounts")) || new Map({})).toList()}
                                        pagination={true}
                                        showTopSection={false}
                                        noRowSelection={true}
                                        keyFilter={"id"}
                                    />
                                </TabPane>
                                <TabPane className={"ml-0"} tab={<div >{"PD Questionnare"}</div>} key="pd_questionare">
                                    <div className={"d-flex justify-content-center"}>{pdDoc && pdDoc.file && pdDoc.file.file ? <iframe src={pdDoc && pdDoc.file && `${process.env.FILE_DOWNLOAD_URL}/${pdDoc.file.file}`} width={"600"} height={800}/>:<Empty />}</div>
                                </TabPane>
                                <TabPane className={"ml-0"} tab="CIBIL Report" key="cibil">
                                    <Table
                                        size={"small"}
                                        columns={CIBIL_DETAILS}
                                        data={(associatesData || new Map({})).map(_ => {
                                            let row = _;
                                            let cibil_report = this.state.cibilDocuments && (this.state.cibilDocuments.find(__ => __.associate == _.id && __.document == 51) || {}).file;
                                            let cibil_supported_report = this.state.cibilDocuments && this.state.cibilDocuments.filter(__ => __.associate == _.id && __.document == 52).map(_ => _.file);
                                            row = row
                                                .set("cibil_report", cibil_report)
                                                .set("cibil_supported_report", new List(cibil_supported_report))
                                                .set("cibil_score", _.getIn(["case_level_data", "cibil_score"]))
                                                .set("cibil_os", _.getIn(["case_level_data", "cibil_os"]))
                                                .set("personal_cibil_score", _.getIn(["case_level_data", "personal_cibil_score"]))
                                                .set("cibil_score_range", _.getIn(["case_level_data", "cibil_score_range"]))
                                                .set("crif_scrore", _.getIn(["case_level_data", "crif_scrore"]))
                                                .set("cibil_remarks", _.getIn(["case_level_data", "cibil_remarks"]))
                                                .set("bureau", _.getIn(["case_level_data", "applicable_bureau"]));
                                            return row;
                                        }).toList()}
                                        pagination={true}
                                        showTopSection={false}
                                        noRowSelection={true}
                                        keyFilter={"id"}
                                    />
                                </TabPane>
                            </Tabs>
                        </Card>
                    </Col> */}
                    <Col className={"p-10"} span={24}>
                        <Tabs className={"ml-0"}
                                    defaultActiveKey={"cam_view"}
                        >
                            <TabPane className={"ml-0"} tab="CAM View" key="cam_view">
                                <CAMView
                                    camEngineData={this.props.camEngineData} 
                                    camEngineStatus={this.props.camEngineStatus}
                                    fetchCamEngineView={this.props.fetchCamEngineView} 
                                    fetchCamEngineStatusLogs={this.props.fetchCamEngineStatusLogs}
                                    fetchCaseDetail={this.props.fetchCaseDetail}
                                    isEmbedded={true}
                                    {...this.props}
                                />
                            </TabPane>
                            {/* <TabPane className={"ml-0"} tab="FI / Bank BRE" key="fi_bre">
                                <AssessmentReviewReport {...this.props}/>
                            </TabPane> */}
                        </Tabs>
                    </Col>
                    {/* {!this.props.isRiskApprover ? <Col className={"p-10"} span={24}>
                        <FinalLimitApprovalList
                            savePdf={this.savePdf}
                            caseId={this.props.caseId}
                            caseTaskId={this.props.caseTaskId}
                            stageId={this.props.stageId}
                            permission={"credit_summary_view"}
                            caseDetail={this.props.caseDetail}
                            referCase={this.props.referCase}
                            user={this.props.user.get("data")}
                            stage={this.props.stage}
                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                            approveCase={this.props.approveCase}
                            getActionModal={this.props.getActionModal}
                            isRiskApprover={this.props.isRiskApprover}
                            stageName={this.props.stageName}
                        />
                    </Col> : null} */}
                    {/* <Col className={"p-10"} span={24}>
                        <BankDocumentView
                            categories={
                                this.props.checklist && this.props.checklist.size && this.props.checklist
                                    .get("data")
                            }
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            documents={this.props.documents.get("data").map(_ => _.get("data"))}
                            droppable={true}
                            deletable={true}
                            viewDocument={this.props.openDocView}
                            uploadFiles={this.props.uploadDocuments.bind(
                                null,
                                this.props.caseId,
                                this.props.companyId
                            )}
                            updateDocument={this.props.updateDocument}
                            attachDocument={
                                this.props
                                    .attachDocument
                            }
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        />
                    </Col> */}
                    <Col className={"p-10"} span={24}>
                    <WelcomeQuestionareTab {...this.props} fullWidth={true}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

FinalCreditSummary.propTypes = {
    stageId: PropTypes.number,
    caseId: PropTypes.number,
    caseTaskId: PropTypes.number,
    companyId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object,
    scorecard: PropTypes.object,
    financials: PropTypes.object, // SupplyChainFinancials Data
    financialsStatus: PropTypes.string, //
    scorecardStatus: PropTypes.string,
    statements: PropTypes.object,
    proposed_limit: PropTypes.number,
    fetchCaseDetail: PropTypes.func,
    fetchCompanyProfile: PropTypes.func,
    initiateCaseState: PropTypes.func,
    fetchCaseSupplyChainFinancials: PropTypes.func,
    fetchScoreCard: PropTypes.func,
    fetchStatement: PropTypes.func,
    checklist: PropTypes.object,
    documents: PropTypes.object,
    fetchDocumentsChecklist: PropTypes.func,
    fetchCaseDocuments: PropTypes.func,
    getActionModal: PropTypes.func,
    openDocView: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    companyStatus: PropTypes.string,
    action: PropTypes.string,
    supplyChainRecord: PropTypes.object,
    supplyChainStatus: PropTypes.string,
    fetchCaseSupplyChainDetails: PropTypes.func,
    approveCase: PropTypes.func,
    referCase: PropTypes.func,
    user: PropTypes.object,
    status: PropTypes.string,
    bank: PropTypes.string,
    data: PropTypes.object,
    userStatus: PropTypes.string,
    isRiskApprover: PropTypes.bool,
    location: PropTypes.object,
    activeBankAccountKey: PropTypes.number,
    companyName: PropTypes.string,
    isUserAllowedToEdit: PropTypes.bool,
    stageName: PropTypes.string,
    stage: PropTypes.object,
    uploadDocuments: PropTypes.func,
    attachDocument: PropTypes.func,
    updateDocument: PropTypes.func,
    caseComments: PropTypes.object,
    fetchCaseNotes: PropTypes.func,
    lendingPartner: PropTypes.func,
    bankStatementAnalyser: PropTypes.object,
    fetchJobsDetails: PropTypes.func,
    fetchJobsList: PropTypes.func,
    fetchStatementAnalysis: PropTypes.func,
    fetchStatementAnalysisPerfois: PropTypes.func,
    use_statement_analyzer: PropTypes.bool,
    caseAssociates: PropTypes.array,
    bankCode: PropTypes.string,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const companyId = state.caseDetails &&
        state.caseDetails.getIn([Number(props.caseId), "data", "company"]);
    return {
        user: state.user,
        userStatus: state.user.get("status"),
        company: state.companies.getIn([props.companyId, "data"]),
        scorecard: state.scorecard.get(props.caseId),
        activeBankAccountKey: (
            state.companies.getIn([props.companyId, "data", "bank_accounts"]) &&
            state.companies
                .getIn([props.companyId, "data", "bank_accounts"])
                .filter(_ => _.is_key_account)
                .first() || {}
        ).id,
        companyStatus:
            companyId ?
                state.companies.getIn([
                    companyId,
                    "status"
                ])
                : null,
        scorecardStatus: state.scorecard.getIn([props.caseId, "status"]),
        financials: state.supplyChain.getIn(["financials", props.caseId, "data"]),
        financialsStatus: state.supplyChain.getIn([
            "financials",
            props.caseId,
            "status"
        ]),
        action: CASE_VIEW_ACTION,
        supplyChainRecord: state.supplyChain.getIn([
            "records",
            props.caseId,
            "data"
        ]),
        status: props.match.params.caseId
            ? state.caseDetails.getIn([Number(props.match.params.caseId), "status"])
            : null,
        supplyChainStatus: state.supplyChain.getIn([
            "records",
            props.caseId,
            "status"
        ]),
        statements: state.statements.get(props.caseId),
        proposed_limit: state.caseDetails.getIn([
            props.caseId,
            "data",
            "proposed_limit"
        ]),
        checklist: state.documents.getIn([
            "checklist",
            "pre-sanction",
            props.caseId
        ]),
        documents: state.documents.getIn(["case_documents", props.caseId]),
        stage: state.stages
            .get("data")
            .find(_ => _.id === props.stageId),
        caseComments: state.caseNotes.get(props.caseId) || new Map({}),
        lendingPartner: state.caseDetails.getIn([props.caseId, "data", "bank", "id"]),
        bankStatementAnalyser: state.bankStatementAnalyser.get(props.caseId),
        use_statement_analyzer: state.caseDetails.getIn([props.caseId, "data", "use_statement_analyzer"]),
        caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"]),
        bankCode: state.caseDetails.getIn([props.caseId, "data", "bank", "code"])
    };
};

export default connect(
    mapStateToProps,
    dispatch =>
        bindActionCreators(
            {
                fetchCaseDetail,
                fetchCompanyProfile,
                initiateCaseState,
                referCase,
                approveCase,
                updateCaseDetail,
                fetchDocumentsChecklist,
                fetchCaseDocuments,
                fetchStatement,
                fetchScoreCard,
                fetchCaseSupplyChainDetails,
                fetchCaseSupplyChainFinancials,
                uploadDocuments,
                attachDocument,
                updateDocument,
                fetchCaseNotes,
                fetchJobsDetails,
                fetchJobsList,
                fetchStatementAnalysis,
                fetchStatementAnalysisPerfois,
                fetchCamEngineView,
                fetchCamEngineStatusLogs
            },
            dispatch
        )
)(FinalCreditSummary);
